import React from "react";
import styled from "@emotion/styled";

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: -webkit-fill-available;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--delete_Container-Background);
  border: 1px solid var(--content_Popup_Border);
`;

const Content = styled.div`
  padding: 8px 0;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

const Message = styled.p`
  color: #7979e9;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
`;

const Button = styled.button`
  color: white;
  border: none;
  padding: 6px 15px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;

  &.yes-button {
    background-color: rgb(42, 167, 57);
  }

  &.no-button {
    background-color: rgb(240, 36, 36);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
`;
const DeleteConfirmation = ({ message, onConfirm, onCancel }) => {
  return (
    <Overlay>
      <Content>
        <Message>
          {message || "Are you sure you want to delete this item?"}
        </Message>
        <ButtonContainer className="delete-button-container">
          <Button className="yes-button" onClick={onConfirm}>
            Yes
          </Button>
          <Button className="no-button" onClick={onCancel}>
            No
          </Button>
        </ButtonContainer>
      </Content>
    </Overlay>
  );
};

export default DeleteConfirmation;
